<template>
  <div class="portal-app-page">
    <RetailerHeader />
    <main class="system-page system-page--portal">
      <section class="system-card system-card--success">
      <span class="system-card__icon system-card__icon--success" uk-icon="icon: check; ratio: 1.7"></span>
      <span class="eyebrow">Order confirmed</span>
      <h1>Thank you for your order</h1>
      <p>Your payment was received and your wholesale order is being prepared.</p>

      <div class="uk-margin-small-top uk-text-meta" v-if="paymentId || orderId">
        <div v-if="paymentId">Payment ID: <code>{{ paymentId }}</code></div>
        <div v-if="orderId">Order ID: <code>{{ orderId }}</code></div>
      </div>

      <div class="system-card__actions">
        <router-link class="uk-button uk-button-primary" :to="{ name: 'Shop' }">
          Continue shopping
        </router-link>
        <router-link
          v-if="orderId"
          class="uk-button uk-button-default uk-margin-small-left"
          :to="{ name: 'Orders' }"
        >
          View my orders
        </router-link>
      </div>
      </section>
    </main>
    <RetailerFooter />
  </div>
</template>

<script>
import RetailerHeader from "./components/RetailerHeader.vue";
import RetailerFooter from './components/RetailerFooter.vue';

export default {
  name: "CheckoutThankYouPage",
  components: { RetailerHeader, RetailerFooter },
  computed: {
    paymentId() {
      // accept pid or paymentId for flexibility
      return this.$route.query.paymentId || this.$route.query.pid || "";
    },
    orderId() {
      return this.$route.query.orderId || "";
    },
  },
};
</script>
